<template>
  <v-select
    :filled="!outlined"
    :outlined="outlined"
    :label="label"
    :name="name"
    :multiple="multiple"
    :type="type"
    :hint="hint"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :rules="rules"
    :readonly="readonly"
    :disabled="disabled"
    :clearable="clearable"
    :return-object="returnObject"
    :hide-details="hideDetails"
    :value="value"
    color="primary"
    class="rounded-lg app-select-no-border"
    @input="e => $emit('input', e)"
    @change="e => $emit('change', e)"
    @click:clear="e => $emit('click:clear', e)"
  >
    <template #prepend-inner v-if="prependInnerIcon">
      <v-icon color="primary" left>
        {{prependInnerIcon}}
      </v-icon>
    </template>
    <template v-slot:selection="data">
      <!-- HTML that describe how select should render selected items -->
      <slot name="selection" v-bind="data">
        <span>{{ data.item[itemText] }}</span>
      </slot>
    </template>
    <template v-slot:item="data">
      <!-- HTML that describe how select should render items when the select is open -->
      <slot name="item" v-bind="data">
        {{ data.item[itemText] }}
      </slot>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'AppSelect',

  props: {
    label: {
      type: String,
      default: ''
    },

    items: {
      type: Array,
      required: true,
    },

    itemText: {
      type: String,
      default: 'text'
    },

    itemValue: {
      type: [String, Number],
      default: 'value'
    },

    value: {
      validator: function (value) {
        return (
          typeof value === 'string' ||
          typeof value === 'number' ||
          typeof value === 'object' ||
          typeof value === 'undefined')
      },
      required: true,
    },

    name: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: ''
    },

    hint: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: ''
    },

    prependInnerIcon: {
      type: String,
      default: ''
    },

    rules: {
      type: Array,
      default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style>
.app-select-no-border.v-text-field--outlined fieldset {
  border: none !important;
} 

.app-select-no-border > .v-input__control > .v-input__slot   {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-select-no-border  > div > .v-input__slot  {
  border: solid 1px var(--v-primary-base) !important;
  color: transparent !important; 
  height: 60px !important;
}

.app-select-no-border .v-text-field__slot,
.app-select-no-border .v-input__prepend-inner,
.app-select-no-border .v-input__slot {
  background-color: #FFFFFF !important;
}

.app-select-no-border  > div.v-input__control > .v-input__slot  {
    border: solid 1px var(--v-primary-base) !important;
    color: transparent !important; 
    height: 60px !important;
}

.app-select-no-border.v-select--is-multi  > div.v-input__control > .v-input__slot  {
    height: auto !important;
    min-height: 60px;
}

.app-select-no-border  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
.app-select-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label {
    color:  var(--v-primary-base);
    font-weight: 600;
}

.app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > input,
.app-select-no-border.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > input,
.app-select-no-border > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections {
    color:  #56565B !important;
}

.app-select-no-border > .v-input__control > .v-input__slot {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-select-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-select-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}

.app-select-no-border.v-select--is-multi > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > span {
   padding-top: 5px !important;
   padding-left:5px !important;
}

.app-select-no-border.v-select--is-multi > .v-input__control > .v-input__slot > .v-select__slot > .v-select__selections > span:not(:last-child)::after {
  content: "\002C";
}

.app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-select-no-border > .v-input__control > .v-input__slot {
  padding-left: 10px !important;
}

.app-select-no-border.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-select-no-border.v-input--is-focused  > .v-input__control > .v-input__slot {
  padding-top: 16px !important;
}

.app-select-no-border  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-select-no-border.error--text  > div > .v-input__slot  {
  border-color: var(--v-error-base) !important;
}

.app-select-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-select-no-border.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}
</style>